(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcgfix-event-calendar"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tcgfix-calendar')) {
  customElements.define('tcgfix-calendar', class extends HTMLElement {
    connectedCallback() {
      if(this.ready) return;
      this.ready = true;
      this.zone = this.dataset.zone;
      this.parts = new Intl.DateTimeFormat('en-US',{timeZone:this.zone,year:'numeric',month:'2-digit',day:'2-digit'});
      this.clock = new Intl.DateTimeFormat('en-US',{timeZone:this.zone,hour:'numeric',minute:'2-digit'});
      this.today = this.key(new Date());
      this.month = new Date(this.today.slice(0,7)+'-01T12:00:00Z');
      this.mode = 'month';
      this.media = matchMedia('(max-width:749px)');
      this.items = [];
      this.undatedItems = [];
      this.selectedLocation = this.selectedLocation || "";
      this.cart = null;
      this.cartBusy = false;
      this.root = this.dataset.root || '/';
      if (!this.root.endsWith('/')) this.root += '/';
      const undated = this.querySelector('.tcgcal-undated');
      undated.lastElementChild.replaceChildren();
      undated.hidden = true;
      this.querySelectorAll('.tcgcal-source-event').forEach(a=>{
        const start = a.dataset.start ? new Date(Number(a.dataset.start)*1000) : null;
        const item = {...a.dataset, url:a.getAttribute('href'), start};
        item.location = (item.location || '').trim().replace(/\s+/g, ' ');
        if(start && !Number.isNaN(start.getTime())) {
          item.day = this.key(start);
          this.items.push(item);
        } else {
          this.undatedItems.push(item);
        }
        a.hidden = true;
      });
      this.items.sort((a,b)=>a.start-b.start);
      const select = this.querySelector('.tcgcal-location');
      select.replaceChildren(this.node('option', '', 'All locations'));
      select.firstElementChild.value = '';
      const locations = new Map();
      [...this.items, ...this.undatedItems].forEach(item => {
        if (item.location) locations.set(this.locationKey(item.location), item.location);
      });
      [...locations].sort((a,b)=>a[1].localeCompare(b[1])).forEach(([key,label])=>{
        const option=this.node('option','',label); option.value=key; select.append(option);
      });
      if (!locations.has(this.selectedLocation)) this.selectedLocation='';
      select.value=this.selectedLocation;
      select.onchange=()=>{ this.selectedLocation=select.value; this.render(); };
      this.querySelector('.tcgcal-filter').hidden=false;
      this.querySelector('.tcgcal-controls').hidden=false;
      this.querySelector('.tcgcal-zone').hidden=false;
      this.onclick = e=>{
        const b = e.target.closest('button');
        if(!b || !this.contains(b)) return;
        if(!b.hasAttribute('data-move') && !b.hasAttribute('data-today') && !b.hasAttribute('data-view')) return;
        if(b.dataset.move) this.month.setUTCMonth(this.month.getUTCMonth()+Number(b.dataset.move));
        if(b.hasAttribute('data-today')) {
          this.today=this.key(new Date());
          this.month=new Date(this.today.slice(0,7)+'-01T12:00:00Z');
        }
        if(b.dataset.view) this.mode=b.dataset.view;
        this.render();
      };
      this.onResize=()=>this.render();
      this.media.addEventListener('change',this.onResize);
      this.render();
      this.onCartFocus = () => { if (!this.cartBusy) this.loadCart(); };
      window.addEventListener('focus', this.onCartFocus);
      this.loadCart();
    }
    disconnectedCallback(){
      if(this.media && this.onResize) this.media.removeEventListener('change',this.onResize);
      window.removeEventListener('focus', this.onCartFocus);
      this.ready=false;
    }
    key(date){
      const p=Object.fromEntries(this.parts.formatToParts(date).map(p=>[p.type,p.value]));
      return `${p.year}-${p.month}-${p.day}`;
    }
    node(tag, cls, text){
      const n=document.createElement(tag); n.className=cls;
      if(text!==undefined) n.textContent=text;
      return n;
    }
    locationKey(value){ return (value || '').trim().replace(/\s+/g,' ').toLowerCase(); }
    matchesLocation(item){ return !this.selectedLocation || this.locationKey(item.location)===this.selectedLocation; }
    card(item){
      const card=this.node('article','tcgcal-card');
      const link=this.node('a','tcgcal-card-link');
      link.href=item.url;
      const soldOut=item.available==='false' && item.detailsOnly!=='true' && item.free!=='true';
      card.dataset.sold=String(soldOut);
      if(item.image){
        const img=this.node('img','tcgcal-image');
        img.src=item.image; img.alt=''; img.loading='lazy'; img.decoding='async';
        link.append(img);
      }
      if(item.start && !Number.isNaN(item.start.getTime())) link.append(this.node('span','tcgcal-time',this.clock.format(item.start)));
      link.append(this.node('strong','',item.title));
      if(item.location) link.append(this.node('span','',item.location));
      link.append(this.node('span','',item.free==='true' ? 'FREE' : item.price));
      const seats=Number(item.seats);
      if(item.detailsOnly!=='true' && item.free!=='true' && !soldOut && item.seats!==undefined && item.seats!=='' && Number.isInteger(seats) && seats>0){
        const availability=seats+' seat'+(seats===1?'':'s')+' left'+(item.repeat==='true'?' across all dates':'');
        link.append(this.node('span','tcgcal-seats-left',availability));
      }
      const eligible=item.single==='true' && item.detailsOnly!=='true' && !!item.variant && !!item.day;
      const label=item.detailsOnly==='true' ? 'View details →' : soldOut ? 'View details →' : item.single!=='true' ? 'Choose options →' : 'View event →';
      link.append(this.node('span','tcgcal-status',label));
      card.append(link);
      if(soldOut){
        card.append(this.node('div','tcgcal-sold-out','SOLD OUT'));
      } else if(eligible){
        const control=this.node('div','tcgcal-quantity');
        control.eventItem=item;
        const minus=this.node('button','','−');
        const count=this.node('output','','…');
        const plus=this.node('button','','+');
        minus.type=plus.type='button';
        minus.setAttribute('aria-label',`Remove one seat for ${item.title}, ${item.day}`);
        plus.setAttribute('aria-label',`Add one seat for ${item.title}, ${item.day}`);
        count.setAttribute('aria-label','Seats in cart');
        minus.onclick=()=>this.changeSeat(item,-1);
        plus.onclick=()=>this.changeSeat(item,1);
        control.append(minus,count,plus);
        card.append(control);
      }
      return card;
    }
    eventProperties(item){
      return item.repeat==='true' ? {
        'Event date':item.day,
        'Event time':this.clock.format(item.start)+' Pacific'
      } : {};
    }
    matchingLines(item){
      const wanted=this.eventProperties(item);
      return (this.cart?.items || []).filter(line=>{
        if(String(line.variant_id)!==String(item.variant) || line.selling_plan_allocation) return false;
        const props=Object.fromEntries(Object.entries(line.properties || {}).filter(([,v])=>v!=='' && v!==null));
        return Object.keys(props).length===Object.keys(wanted).length && Object.entries(wanted).every(([k,v])=>props[k]===v);
      });
    }
    message(text){
      this.querySelector('.tcgcal-cart-message').textContent=text;
    }
    syncControls(){
      this.querySelectorAll('.tcgcal-quantity').forEach(control=>{
        const item=control.eventItem;
        const quantity=this.matchingLines(item).reduce((sum,line)=>sum+line.quantity,0);
        const buttons=control.querySelectorAll('button');
        control.querySelector('output').textContent=this.cart ? String(quantity) : '…';
        buttons[0].disabled=this.cartBusy || !this.cart || quantity===0;
        buttons[1].disabled=this.cartBusy || item.available==='false';
        control.setAttribute('aria-busy',String(this.cartBusy));
      });
      const count=this.querySelector('.tcgcal-cart-count');
      if(count) count.textContent=this.cart ? `(${this.cart.item_count})` : '';
    }
    async cartRequest(endpoint,body){
      const response=await fetch(this.root+endpoint,{
        method:body ? 'POST' : 'GET', credentials:'same-origin', cache:'no-store',
        headers:{'Accept':'application/json',...(body ? {'Content-Type':'application/json'} : {})},
        ...(body ? {body:JSON.stringify(body)} : {})
      });
      const data=await response.json();
      if(!response.ok) throw new Error(typeof data.description==='string' ? data.description : typeof data.message==='string' ? data.message : 'Unable to update your cart. Please try again.');
      return data;
    }
    async loadCart(){
      try { this.cart=await this.cartRequest('cart.js'); }
      catch { this.cart=null; this.message('Cart could not load. Use View cart to check it, or press + to try again.'); }
      this.syncControls();
    }
    updateThemeCart(sections){
      if(!sections) return;
      const drawer=document.querySelector('cart-drawer');
      if(drawer && typeof drawer.renderContents==='function' && sections['cart-drawer'] && sections['cart-icon-bubble']){
        drawer.classList.toggle('is-empty',this.cart.item_count===0);
        drawer.renderContents({sections});
        return;
      }
      if(sections['cart-icon-bubble']){
        const doc=new DOMParser().parseFromString(sections['cart-icon-bubble'],'text/html');
        const source=doc.querySelector('.shopify-section');
        const target=document.getElementById('cart-icon-bubble');
        if(source && target) target.innerHTML=source.innerHTML;
      }
    }
    async changeSeat(item,delta){
      if(this.cartBusy || this.constructor.mutatingCart) return;
      if(item.detailsOnly==='true' || item.single!=='true' || !item.day || !item.variant) return;
      if(delta>0 && item.available==='false') return;
      this.constructor.mutatingCart=true;
      this.cartBusy=true;
      this.message('Updating cart…');
      this.syncControls();
      try {
        // Read immediately before a change; never blindly replace another cart line.
        this.cart=await this.cartRequest('cart.js');
        const sections=['cart-icon-bubble'];
        if(document.querySelector('cart-drawer')) sections.push('cart-drawer');
        const shared={sections,sections_url:window.location.pathname};
        let result;
        if(delta>0){
          result=await this.cartRequest('cart/add.js',{
            items:[{id:item.variant,quantity:1,properties:this.eventProperties(item)}],...shared
          });
        } else {
          const lines=this.matchingLines(item);
          const line=lines[lines.length-1];
          if(!line){ this.message('No seats for this event are in your cart.'); return; }
          result=await this.cartRequest('cart/change.js',{id:line.key,quantity:line.quantity-1,...shared});
        }
        this.cart=await this.cartRequest('cart.js');
        this.message(delta>0 ? 'Seat added to your cart.' : 'Seat removed from your cart.');
        try { this.updateThemeCart(result.sections); } catch { /* View cart remains available. */ }
        document.dispatchEvent(new CustomEvent('tcgfix:cart-updated',{detail:{cart:this.cart}}));
      } catch(error){
        // A rejected add can still be partially fulfilled by Shopify. Always re-read.
        try { this.cart=await this.cartRequest('cart.js'); }
        catch { this.cart=null; }
        this.message((error.message || 'Cart update failed.')+' Check View cart before trying again.');
      } finally {
        this.cartBusy=false;
        this.constructor.mutatingCart=false;
        this.syncControls();
      }
    }
    render(){
      const out=this.querySelector('.tcgcal-output'); out.replaceChildren();
      const undated=this.querySelector('.tcgcal-undated');
      const undatedItems=this.undatedItems.filter(item=>this.matchesLocation(item));
      undated.lastElementChild.replaceChildren(...undatedItems.map(item=>this.card(item)));
      undated.hidden=undatedItems.length===0;
      const label=this.month.toLocaleDateString('en-US',{timeZone:'UTC',month:'long',year:'numeric'});
      this.querySelector('.tcgcal-nav h2').textContent=label;
      this.querySelectorAll('[data-view]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.view===this.mode)));
      const prefix=this.month.toISOString().slice(0,7);
      const daysInMonth = new Date(Date.UTC(
  this.month.getUTCFullYear(),
  this.month.getUTCMonth() + 1,
  0
)).getUTCDate();
const items = this.items.filter(event=>this.matchesLocation(event)).flatMap(event => {
  if (event.repeat !== 'true') {
    return event.day.startsWith(prefix) ? [event] : [];
  }
  const seedDay = Date.parse(event.day + 'T00:00:00Z');
  const occurrences = [];
  for (let day = 1; day <= daysInMonth; day++) {
    const key = prefix + '-' + String(day).padStart(2, '0');
    const difference = Math.round(
      (Date.parse(key + 'T00:00:00Z') - seedDay) / 86400000
    );
    if (
      difference >= 0 &&
      difference % 7 === 0 &&
      (!event.until || key <= event.until)
    ) {
      occurrences.push({ ...event, day: key });
    }
  }
  return occurrences;
});
items.sort((a, b) => a.day.localeCompare(b.day));
      const grouped=new Map();
      items.forEach(e=>{if(!grouped.has(e.day))grouped.set(e.day,[]);grouped.get(e.day).push(e);});
      if(this.mode==='agenda' || this.media.matches){
        for(const [day,events] of grouped){
          const row=this.node('section','tcgcal-agenda-day');
          row.append(this.node('h3','',new Date(day+'T12:00:00Z').toLocaleDateString('en-US',{timeZone:'UTC',weekday:'short',month:'short',day:'numeric'})));
          const cards=this.node('div','');events.forEach(e=>cards.append(this.card(e)));row.append(cards);out.append(row);
        }
      }else{
        const grid = this.node('div', 'tcgcal-grid');
// Find how much space each weekday needs this month.
const weekdayCounts = Array(7).fill(0);
for (const [day, events] of grouped) {
  const weekday = new Date(day + 'T12:00:00Z').getUTCDay();
  weekdayCounts[weekday] = Math.max(
    weekdayCounts[weekday],
    events.length
  );
}
// Flexible tracks resize with the calendar container, without a fixed minimum.
// Busy weekdays get at most twice the space of a regular weekday.
grid.style.gridTemplateColumns = weekdayCounts.map(count =>
  `minmax(0, ${Math.min(Math.max(count, 1), 2)}fr)`
).join(' ');
        ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'].forEach(d=>grid.append(this.node('div','tcgcal-weekday',d)));
        const offset=this.month.getUTCDay();
        const total=new Date(Date.UTC(this.month.getUTCFullYear(),this.month.getUTCMonth()+1,0)).getUTCDate();
        const cells=Math.ceil((offset+total)/7)*7;
        for(let i=0;i<cells;i++){
          const day=i-offset+1;
          if(day<1 || day>total){const blank=this.node('div','tcgcal-day tcgcal-blank');blank.setAttribute('aria-hidden','true');grid.append(blank);continue;}
          const key=prefix+'-'+String(day).padStart(2,'0');
          const cell=this.node('section','tcgcal-day');cell.dataset.current=String(key===this.today);
          cell.setAttribute('aria-label',`${label} ${day}`);
          cell.append(this.node('span','tcgcal-number',String(day)));
          const dayEvents=this.node('div','tcgcal-day-events');
          (grouped.get(key)||[]).forEach(e=>dayEvents.append(this.card(e)));
          cell.append(dayEvents);grid.append(cell);
        }
        out.append(grid);
      }
      this.syncControls();
      this.querySelector('.tcgcal-filter-count').textContent=items.length+' event'+(items.length===1?'':'s')+' this month'+(undatedItems.length ? ' · '+undatedItems.length+' undated' : '');
      if(!items.length)out.append(this.node('p','tcgcal-empty',this.selectedLocation ? 'No dated events at this location this month. Choose All locations or try another month.' : 'No dated events listed for this month. Try another month or check More events below.'));
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
